exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3hicOYyuBNDn82hjmRl52v{position:relative;-moz-user-select:-moz-none}._3hicOYyuBNDn82hjmRl52v:focus{outline:none}._3hicOYyuBNDn82hjmRl52v *{-moz-user-select:-moz-none}._3XJeeltOJBIkpN1IPUZh85:after{content:\"\";position:absolute;display:block;top:-1px;right:-1px;bottom:-1px;left:-1px;border:2px solid #8fb9ec;pointer-events:none}\n", ""]);

// Exports
exports.locals = {
	"Block": "_3hicOYyuBNDn82hjmRl52v",
	"isSelected": "_3XJeeltOJBIkpN1IPUZh85"
};